module.exports = __webpack_public_path__ + "static/media/BCFS_DRUPS.188fd7d7.jpg";